// ── Metin normalizasyonu (arama / karşılaştırma için) ─────────────────────────
//
// Türkçe'ye özgü büyük/küçük harf katlaması JS'in varsayılan toLowerCase'inde
// bozuktur: "Irmak".toLowerCase() → "irmak" ama "İ".toLowerCase() → "i̇" (birleşik
// noktalı i) üretir; dolayısıyla "ı" ile arama "İ/I" içeren kayıtları bulamaz.
//
// normalizeTr, aramayı hem büyük/küçük harf hem de diyakritik duyarsız yapmak için
// Türkçe karakterleri ASCII karşılıklarına indirger. Tüm "i" varyantları (İ, I, ı, i)
// tek bir "i"de birleşir — böylece "Irmak" hangi i ile aranırsa aransın bulunur.

const TR_CHAR_MAP = {
  ç: 'c', Ç: 'c',
  ğ: 'g', Ğ: 'g',
  ı: 'i', İ: 'i', I: 'i',
  ö: 'o', Ö: 'o',
  ş: 's', Ş: 's',
  ü: 'u', Ü: 'u',
};

/**
 * Bir metni arama/karşılaştırma için normalize eder:
 * Türkçe karakterleri ASCII'ye indirger, küçük harfe çevirir, kalan diyakritikleri
 * (aksanlı latin harfleri vb.) temizler ve baştaki/sondaki boşlukları kırpar.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeTr(value) {
  if (value == null) return '';
  return String(value)
    .replace(/[çÇğĞıİIöÖşŞüÜ]/g, (ch) => TR_CHAR_MAP[ch])
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '') // kalan birleşik diyakritikleri sil
    .trim();
}
